import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import { adminRoutes } from './adminRoutes';


const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/LoginView.vue'),
    },
    {
        path: '/setpassword',
        name: 'setpassword',
        component: () => import( '@/views/SetPasswordView.vue'),
    },
    {
        path: '/',
        name: 'startUp',
        // redirect: '/previous-runs',
        component: () => import(/* webpackChunkName: "startUp" */ '@/views/StartUpView.vue'),
    },
    {
        path: '/upload-results',
        name: 'uploadResults',
        component: () => import(/* webpackChunkName: "uploadResults" */ '@/views/UploadResultsView.vue'),
    }, 
    {
        path: '/finished-runs',
        name: 'finishedRuns',
        component: () => import(/* webpackChunkName: "finishedRuns" */ '@/views/FinishedRunsView.vue'),
    }, 
    {
        path: '/profiles',
        name: 'profiles',
        component: () => import(/* webpackChunkName: "profiles" */ '@/views/PreviousProfilesView.vue'),
    },
    {
        path: '/run-results',
        name: 'runResults',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/RunResultsView.vue'),
    },
    // samples
    {
        path: '/new-samples',
        name: 'newSamples',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/NewSampleView.vue'),
    },
    // tests
    {
        path: '/tests',
        name: 'tests',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/NewTestView.vue'),
    },
    // submitted questionnaires
    {
        path: '/submitted-questionnaires',
        name: 'submittedQuestionnaires',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/SubmittedQuestionnairesView.vue'),
    },
    // rails
    {
        path: '/rails',
        name: 'rails',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/TenantRailsView.vue'),
    },
    // Questionnaire504
    {
        path: '/504/questionnaire/tables',
        name: 'Questionnaire504-TABLES',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/Questionnaire504Tables.vue'),
    },
    {
        path: '/504/questionnaire/assessment',
        name: 'Questionnaire504-ASSESSMENT',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/ConsultantAssessmentView.vue'),
        props: true
    },
    {
        path: '/504/preview-assessment',
        name: 'preview-assessment',
        // redirect: '/previous-runs',
        component: () => import(/* webpackChunkName: "startUp" */ '@/views/PreviewAssessmentView.vue'),
    },
    {
        path: '/504/questionnaire/general',
        name: 'Questionnaire504-GENERAL',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/Questionnaire504.vue'),
    },
    {
        path: '/504/questionnaire/wire',
        name: 'Questionnaire504-WIRE',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/Questionnaire504.vue'),
    },
    {
        path: '/504/questionnaire/ach',
        name: 'Questionnaire504-ACH',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/Questionnaire504.vue'),
    },
    {
        path: '/504/questionnaire/instant-payment',
        name: 'Questionnaire504-RTP',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/Questionnaire504.vue'),
    },
    {
        path: '/504/questionnaire/monitoring',
        name: 'Questionnaire504-MONITORING',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/Questionnaire504.vue'),
    },

    {
        path: '/504/test/name-matching',
        name: 'Questionnaire504-NAME-MATCHING',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/NameMatchingView.vue'),
    },
    // Questionnaire504-WIRES-SCREENING
    {
        path: '/504/test/wires-screening',
        name: 'Questionnaire504-WIRES-SCREENING',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/WiresScreeningTestView.vue'),
    },
    // Questionnaire504-MONITORING
    {
        path: '/504/test/monitoring',
        name: 'Questionnaire504-MONITORING-TEST',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/MonitoringTestView.vue'),
    },
    {
        path: '/504/questionnaire/assessment/complete',
        name: 'Questionnaire504-FINISHED-ASSESSMENT',
        component: () => import(/* webpackChunkName: "RunResults" */ '@/views/ReviewAssessmentView.vue'),
    },
    ...adminRoutes
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (to) => {   
    const isAuthenticated = store.getters['isAuthenticated'];
    
    if (!isAuthenticated && !['login', 'setpassword'].includes(to.name)) {
        return { name: 'login' };
    }
    if (isAuthenticated && to.name === 'login') {
        return { name: 'startUp' };
    }
});

export default router;
